import { BagSVG as BagSVG_v2 } from '@core/assets/BagSVG.v2';
import { customAssetOrSrc } from '@core/assets/customAssetOrSrc';
import { AccessibleIcon } from '@core/components/AccessibleIcon/AccessibleIcon';
import { useStore } from '@core/widgets/store';
import { ProductTagContainer } from './ProductTag.styles';
/**
 *
 */
export const ProductTag = ({ small }) => {
    const params = useStore((state) => state.params);
    return (<ProductTagContainer small={small} aria-hidden={true}>
      <AccessibleIcon src={customAssetOrSrc(params?.ui_asset_product_tag) || (<BagSVG_v2 circle label="" aria-hidden/>)} width="100%" height="100%" label="" aria-hidden/>
    </ProductTagContainer>);
};
